import { forwardRef, type ChangeEvent } from 'react';

import { formatPhoneGT } from '@/shared/lib/format-phone-gt';
import { Input, type InputProps } from '@/shared/ui/shadcn/input';

export type PhoneInputGTProps = Omit<InputProps, 'type'>;

/**
 * Input de teléfono con máscara `NNNN-NNNN` para Guatemala.
 *
 * Reutilizado por los formularios de crear/editar usuario. Aplica
 * `formatPhoneGT` en cada `onChange` antes de propagar el evento, así
 * el caller (incluyendo `react-hook-form`) recibe siempre el valor ya
 * formateado. Los defaults de UX (`type="tel"`, `inputMode="numeric"`,
 * `autoComplete="tel-national"`, `placeholder="4444-4444"`,
 * `maxLength={9}`) se pueden sobreescribir vía props.
 */
export const PhoneInputGT = forwardRef<HTMLInputElement, PhoneInputGTProps>(
  (
    {
      onChange,
      inputMode = 'numeric',
      autoComplete = 'tel-national',
      placeholder = '4444-4444',
      maxLength = 9,
      ...props
    },
    ref,
  ) => {
    return (
      <Input
        ref={ref}
        type="tel"
        inputMode={inputMode}
        autoComplete={autoComplete}
        placeholder={placeholder}
        maxLength={maxLength}
        onChange={(event: ChangeEvent<HTMLInputElement>) => {
          event.target.value = formatPhoneGT(event.target.value);
          onChange?.(event);
        }}
        {...props}
      />
    );
  },
);
PhoneInputGT.displayName = 'PhoneInputGT';
